import { Platform } from 'react-native'

import Checkbox, { CheckboxProps } from 'app/components/base/Checkbox'

import withFacet, { FacetComponentProps } from '../components/withFacet'

type CheckboxFilterProps = CheckboxProps &
  FacetComponentProps & {
    handleChange: ({
      value,
      onChange,
      onRemove
    }: {
      value: boolean
      onChange: (value: unknown) => void
      onRemove: (value: unknown) => void
    }) => void
  }

const CheckboxFilter: RFC<CheckboxFilterProps> = ({
  label,
  filter: { values, onChange, field, onRemove },
  handleChange
}) => {
  const value = values.flat()[0]

  return (
    // @ts-ignore
    <Checkbox
      label={label}
      name={field}
      value={value}
      checked={!!value || false}
      // @ts-ignore
      {...Platform.select({
        web: {
          onChange: (_, value) => handleChange({ value, onChange, onRemove })
        },
        native: {
          onChange: (value: boolean) =>
            handleChange({ value, onChange, onRemove })
        }
      })}
    />
  )
}

export default withFacet(CheckboxFilter)
